module.exports = __webpack_public_path__ + "img/js3.ba311bc0.jpg";